"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMnemonicDarkTheme = void 0;
const tslib_1 = require("tslib");
const styles_1 = require("@mui/material/styles");
const createPalette_1 = tslib_1.__importStar(require("./createPalette"));
function createMnemonicDarkTheme(options, ...localeObjects) {
    const palette = (0, createPalette_1.default)({
        primary: {
            contrastText: (0, createPalette_1.getContrastText)("#3DB6B9", 3),
            dark: "#009796",
            main: "#3DB6B9",
            light: "#B0DFE1",
        },
        secondary: {
            contrastText: (0, createPalette_1.getContrastText)("#FF8956", 3),
            dark: "#FE6F2E",
            main: "#FF8956",
            light: "#FFCCB6",
        },
        mode: "dark",
        ...options?.palette,
    });
    const theme = (0, styles_1.createTheme)({
        ...options,
        palette,
        components: Object.assign({
            ...options?.components,
            MuiAppBar: {
                ...options?.components?.MuiAppBar,
                defaultProps: {
                    elevation: 0,
                },
            },
            MuiAutocomplete: {
                ...options?.components?.MuiAutocomplete,
                defaultProps: {
                    componentsProps: {
                        paper: {
                            elevation: 8,
                        },
                    },
                },
            },
            MuiCheckbox: {
                ...options?.components?.MuiCheckbox,
                defaultProps: { color: "secondary" },
            },
            MuiLink: {
                ...options?.components?.MuiLink,
                defaultProps: { color: "textPrimary" },
                styleOverrides: { root: ({ theme }) => ({ "&:hover": { color: theme.palette.secondary.main } }) },
            },
        }, {
            MuiPaper: {
                ...options?.components?.MuiPaper,
                defaultProps: {
                    elevation: 2,
                },
            },
            MuiRadio: {
                ...options?.components?.MuiRadio,
                defaultProps: {
                    color: "secondary",
                },
            },
            MuiSwitch: {
                ...options?.components?.MuiSwitch,
                defaultProps: {
                    color: "secondary",
                },
            },
            MuiTableCell: {
                ...options?.components?.MuiTableCell,
                styleOverrides: {
                    // This class is automatically applied to all th cells when setting stickyHeader on the Table component
                    stickyHeader: ({ theme }) => ({
                        backgroundColor: (0, styles_1.lighten)(theme.palette.background.paper, 0.15),
                    }),
                },
            },
            MuiTooltip: {
                ...options?.components?.MuiTooltip,
                styleOverrides: {
                    tooltip: ({ theme }) => ({
                        fontSize: 14,
                        padding: theme.spacing(1, 2),
                    }),
                },
            },
        }),
    }, ...localeObjects);
    /**
     * Non enumerable property defined so that we are able to identify the theme by name
     * after the theme object is created.
     */
    Object.defineProperty(theme, "__MNEMONIC_THEME__", { value: "mnemonic_dark", enumerable: false });
    return theme;
}
exports.createMnemonicDarkTheme = createMnemonicDarkTheme;
